import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProtectedBuilder from './components/ProtectedBuilder';
import LandingPage from './components/LandingPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<ProtectedBuilder />} />
          <Route path="/:pageSlug" element={<LandingPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;